module.exports = window["braintree"]["dropin"];